import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
    FaUserPlus, 
    FaUsers, 
    FaChevronRight
} from 'react-icons/fa';

const ActionCard = ({ title, description, icon, color, onClick, topBorderColor }) => (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden flex flex-col hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group">
        <div className={`h-1.5 w-full ${topBorderColor}`}></div>
        <div className="p-8 flex flex-col items-center text-center flex-grow">
            <div className={`w-16 h-16 ${color} rounded-2xl flex items-center justify-center text-white mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                {React.cloneElement(icon, { size: 28 })}
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-blue-600 transition-colors uppercase tracking-tight">{title}</h3>
            <p className="text-sm text-gray-400 font-bold uppercase tracking-wider">{description}</p>
        </div>
        <div 
            className="px-8 py-5 border-t border-gray-50 flex items-center justify-between cursor-pointer hover:bg-blue-50/30 transition-colors" 
            onClick={onClick}
        >
            <span className="text-xs font-black text-gray-400 group-hover:text-blue-600 transition-colors uppercase tracking-[0.2em]">निवडा</span>
            <div className="w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center group-hover:bg-blue-100 transition-colors">
                <FaChevronRight className="text-gray-300 group-hover:text-blue-500 transition-colors text-[10px]" />
            </div>
        </div>
    </div>
);

const AuditEngineerMenu = () => {
    const navigate = useNavigate();

    const options = [
        {
            title: "नवीन सु.बे. अभियंत्यांची यादी",
            description: "New Engineer Registration List",
            icon: <FaUserPlus />,
            color: "bg-blue-600",
            topBorderColor: "bg-blue-600",
            path: "/audit/engineers/new" 
        },
        {
            title: "जुने सु.बे. अभियंत्यांची यादी",
            description: "Old Engineer Registration List",
            icon: <FaUsers />,
            color: "bg-emerald-600",
            topBorderColor: "bg-emerald-600",
            path: "/audit/engineers/old"
        }
    ];

    return (
        <div className="min-h-[80vh] flex flex-col">
            {/* Header Section */}
            <div className="bg-[#1a1c23] rounded-[1.25rem] p-10 mb-12 flex justify-between items-center shadow-xl relative overflow-hidden">
                <div className="relative z-10">
                    <h1 className="text-4xl font-black text-white mb-2">
                        सु.बे. अभियंता <span className="font-bold">(Engineers)</span>
                    </h1>
                    <p className="text-gray-400 text-sm font-medium">
                        यादी निवडण्यासाठी खालील पर्यायांवर क्लिक करा
                    </p>
                </div>
                
                <button 
                    onClick={() => navigate(-1)}
                    className="bg-[#2d2f39] hover:bg-[#383a45] text-white px-8 py-3 rounded-xl font-bold text-sm transition-all duration-300 active:scale-95 shadow-lg border border-white/5"
                >
                    मागे जा
                </button>
            </div>

            {/* Cards Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-4xl mx-auto w-full">
                {options.map((option, index) => (
                    <ActionCard 
                        key={index}
                        {...option}
                        onClick={() => navigate(option.path)}
                    />
                ))}
            </div>
        </div>
    );
};

export default AuditEngineerMenu;
